import { SnapCarouselPage, SnapCarouselPaginator, SnapCarrouselItem, SnapCarrouselRoot } from "./SnapCarrousel.styles";
import clsx from "clsx";
import { SnapCarrouselProps } from "./SnapCarrousel.types";
import NothingToShow from "../../feedback/NothingToShow/NothingToShow";
import useSnapCarousel from "./hooks/useSnapCarousel";

function SnapCarrousel<SP extends Record<string, unknown>>({
    className,
    gap,
    fullWidth,
    nothingToShow = <NothingToShow />,
    showPagination,
    ...rest
}: SnapCarrouselProps<SP>) {
    const { onClickBanner, items, hasElements, itemRefs, currentPage, containerRef } = useSnapCarousel(rest);
    return (
        <div>
            <SnapCarrouselRoot
                data-testid="carousel-list"
                ref={containerRef}
                gap={gap}
                key={items.length}
                className={clsx("snap-carrousel", className)}
                {...rest}
            >
                {hasElements
                    ? items.map((child, index) => (
                          <SnapCarrouselItem
                              fullWidth={fullWidth}
                              ref={(el) => (itemRefs.current[index] = el)}
                              // skipcq
                              key={index}
                              className="snap-carrousel-item"
                          >
                              {child}
                          </SnapCarrouselItem>
                      ))
                    : nothingToShow}
            </SnapCarrouselRoot>
            {showPagination && (
                <SnapCarouselPaginator data-testid="snap-carousel-pagination">
                    {hasElements &&
                        items.map((_, index) => (
                            <SnapCarouselPage
                                selected={index === currentPage}
                                onClick={() => onClickBanner(index)}
                                // skipcq
                                key={index}
                                className="snap-carrousel-page"
                            />
                        ))}
                </SnapCarouselPaginator>
            )}
        </div>
    );
}

export default SnapCarrousel;
